import { useTranslation } from 'react-i18next';
import { itensSeletorEmpresa } from '../../nucleo/empresa/SeletorEmpresa';
import { useSessao, type EmpresasDaSessao } from '../../nucleo/sessao';
import { AtalhoRapido, opcoesDoAtalho } from './AtalhoRapido';
import { SeletorEmpresaBarra } from './SeletorEmpresaBarra';

/**
 * Encaixe da direita (empresa) da barra do desktop. No celular (review r16 visual M1 e r17 visual M1) o seletor de empresa
 * fica numa linha própria do cabeçalho (`EncaixesBarra celular="faixa"`). Fase 2 (W31, item 2): o sino saiu (virou o item
 * "Notificações" do menu lateral) e a faixa de índices também (virou Financeiro > Índices).
 */
export function EncaixesBarra({ celular }: { celular?: 'faixa' }) {
  const s = useSessao();
  if (!seletorEmpresaNoTopo(s.empresas)) return null;
  return <SeletorEmpresaBarra celular={celular === 'faixa'} />;
}

/**
 * Fase 2 (W31): a barra do desktop só existe quando tem o que mostrar. 22/10 (Gustavo): o filtro de vertical fica nos filtros
 * de cada página; o seletor do topo só aparece com um filtro de empresa ativo na aba (escolhido em "Trocar empresa ou
 * sub-sistema" ou no conector), para voltar a "Minhas verticais".
 */
export const seletorEmpresaNoTopo = (empresas: EmpresasDaSessao | undefined) => itensSeletorEmpresa(empresas, '') !== null && empresas?.todas === false;
export const barraSuperiorTemConteudo = (empresas: EmpresasDaSessao | undefined, comAtalho = false) => comAtalho || seletorEmpresaNoTopo(empresas);

/**
 * Fase 2 (W1, A5 5.10): barra superior fixa do desktop (lg+), com o mesmo fundo e a mesma borda do cabeçalho do celular.
 * Fica abaixo da faixa de ambiente (`topo-faixa`). Fase 2 (W31): sem os índices e o sino, sobra o seletor de empresa, à
 * direita; com uma empresa só, a barra não é desenhada (nada de faixa vazia de 40 px no topo).
 */
export function BarraSuperior() {
  const { t } = useTranslation();
  const s = useSessao();
  // U15 F8: o atalho rápido também faz a barra existir (com uma empresa só e ao menos uma opção do atalho).
  if (!barraSuperiorTemConteudo(s.empresas, opcoesDoAtalho(s).length > 0)) return null;
  return (
    <div data-sem-impressao data-barra-superior role="group" aria-label={t('barra.titulo')} className="topo-faixa sticky z-20 hidden h-10 items-center gap-3 border-b border-borda bg-fundo px-4 lg:flex lg:px-8">
      <div className="ml-auto flex min-w-0 shrink-0 items-center gap-2">
        <AtalhoRapido />
        <EncaixesBarra />
      </div>
    </div>
  );
}
